export default (theme) => ({
	wrapper: {
		'& > *': {
			zIndex: theme.zIndex.tooltip
		}
	},

	popperWrapper: {
		width: 'max-content'
	},

	popper: {
		minWidth: 160,
		width: 'auto',
		zIndex: theme.zIndex.tooltip,
		boxSizing: 'border-box',

		'&.lg': {
			width: 600,
			marginTop: -3
		}
	},

	popperOnClose: {
		pointerEvents: 'none'
	}
});
